module.exports = __webpack_public_path__ + "static/media/31.05a92b5a.png";